/**
 * Generate a v4 UUID/GUID
 *
 * @returns A random generated string
 */
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function getUuidV4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
/**
 * Generate a random string
 *
 * @returns A random generated string
 */
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function getRandomString() { return Math.random().toString(36).substring(2); }
export { getUuidV4, getRandomString };
//# sourceMappingURL=random.js.map